export default {
  "b2b.produkt-detail.title-placeholder": "Product",
  "b2b.produkt-detail.message-empty": "Product not found"
};
